module.exports = __webpack_public_path__ + "img/logo_m.0ef1f90e.png";